var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipseyellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 218,
    viewBox: "0 0 202 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 165.5,
    r: 165.5,
    fill: "#9A8C6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseyellow);
export default __webpack_public_path__ + "static/media/Ellipseyellow.9b21c591aea7c36fd9e4566b4369720d.svg";
export { ForwardRef as ReactComponent };